<template>
    <header id="headerId" class="header fixed-top background-scroll" v-bind:class="{ 'solid': this.classHeader}">
        <div class="container d-flex align-items-center">
            <div class="logo" :class="{active : this.headerState}">BlackTorrent</div>
            <div class="header-nav" :class="{open : this.headerState}">
                <nav>
                    <ul class="primary-nav">
                        <li v-for="menu in listMenu" :key="menu.name">
                            <a v-on:click="handleClick()" v-scroll-to="{ el: '#'+menu.links, duration:3000,offset:-58}">{{menu.name}}</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="navicon">
                <a class="nav-toggle" :class="{active : this.headerState}" v-on:click="handleClick()"><span/></a>
            </div>
        </div>
    </header>
</template>

<script>
import '../assets/css/Header.css'
import listMenu from './ListMenu'

export default {
    name : 'HeaderComponent',
    data() {
        return {
            headerState: false,
            classHeader: false,
            listMenu
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods : {
        handleClick(){
            this.headerState = !this.headerState;
        },
        handleScroll () {
            // let header = document.getElementById('headerId').clientHeight

            if (window.scrollY > 0){
                this.classHeader = true
            } else {
                this.classHeader = false
            }
        },
    },
}
</script>